import { Button, Dropdown, Form, Input, Layout, Menu, Modal, PageHeader, Select, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useForm } from 'antd/lib/form/Form';
import { apiClient, apiErrorMessage } from '../../../utils';
import { BookOutlined, EllipsisOutlined, ExclamationCircleOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { Dictionary } from '../../../models';

export function DictionaryPage() {
  const { Content } = Layout;
  const { Text } = Typography;
  const [dictionaries, setDictionaries] = useState<Dictionary[]>();
  const [loading, setLoading] = useState(false);
  const [form] = useForm();
  const [editDictionaryId, setEditDictionaryId] = useState('');
  const [editDictionaryModalVisible, setEditDictionaryModalVisible] = useState(false);

  const columns = [
    {
      title: 'Doğru terim',
      dataIndex: 'correctTerm',
      key: 'correctTerm',
    },
    {
      title: 'Alternatif terimler',
      dataIndex: 'termsGroup',
      key: 'termsGroup',
      render: (text: any) => {
        return <span>{text.join(', ')}</span>;
      },
    },
    {
      key: 'action',
      render: (text: any, record: any) => (
        <div style={{ textAlign: 'right' }}>
          <Dropdown overlay={tableActions(record.id)} trigger={['click']}>
            <Button size="small" icon={<EllipsisOutlined />} />
          </Dropdown>
        </div>
      ),
    },
  ];

  const onRefreshClick = () => {
    loadDictionaries();
  };

  const tableActions = (id: string) => {
    return (
      <Menu onClick={(e: any) => onGridActionClick(e, id)}>
        <Menu.Item key="edit">
          <Text>Düzenle</Text>
        </Menu.Item>
        <Menu.Item key="del">
          <Text type="danger">Sil</Text>
        </Menu.Item>
      </Menu>
    );
  };

  const onGridActionClick = (e: any, id: string) => {
    if (e.key === 'del') {
      confirmDeleteDictionary(id);
    } else if (e.key === 'edit') {
      openDictionaryEditModal(id);
    }
  };

  const confirmDeleteDictionary = (id: string) => {
    const onOk = () => deleteDictionary(id);
    Modal.confirm({
      title: 'Kayıt silme',
      icon: <ExclamationCircleOutlined />,
      content: 'Kaydı silmek istediğinizden emin misiniz?',
      onOk,
    });
  };

  const deleteDictionary = (id: string) => {
    setLoading(true);
    apiClient
      .delete(`dictionaries/${id}`)
      .then(() => {
        loadDictionaries();
      })
      .catch(apiErrorMessage)
      .finally(() => {
        setLoading(false);
      });
  };

  const openDictionaryEditModal = (id: string) => {
    const dictionary = dictionaries?.find((d: any) => d.id === id);
    if (!dictionary) {
      return;
    }
    form.setFieldsValue(dictionary);
    setEditDictionaryId(id);
    setEditDictionaryModalVisible(true);
  };

  const loadDictionaries = () => {
    setLoading(true);
    apiClient
      .get('dictionaries')
      .then((response: any) => {
        setDictionaries(response.data);
      })
      .catch(apiErrorMessage)
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadDictionaries();
  }, []);

  const addDictionaryModal = () => {
    form.resetFields();
    setEditDictionaryId('');
    setEditDictionaryModalVisible(true);
  };

  const onModalOk = () => {
    form
      .validateFields()
      .then(values => {
        const method = editDictionaryId ? 'put' : 'post';
        const url = editDictionaryId ? `dictionaries/${editDictionaryId}` : 'dictionaries';
        setLoading(true);
        apiClient[method](url, values)
          .then(() => {
            loadDictionaries();
            form.setFieldsValue({});
            setEditDictionaryModalVisible(false);
          })
          .catch(apiErrorMessage)
          .finally(() => {
            setLoading(false);
          });
      })
      .catch(() => {});
  };

  return (
    <>
      <PageHeader
        title={
          <>
            <BookOutlined /> Sözlük
          </>
        }
        extra={[
          <Button key="refresh" onClick={onRefreshClick} icon={<ReloadOutlined />}>
            Yenile
          </Button>,
          <Button type="primary" key="add" icon={<PlusOutlined />} onClick={addDictionaryModal}>
            Yeni terim
          </Button>,
        ]}
      />
      <Content>
        <Table
          columns={columns}
          dataSource={dictionaries}
          loading={loading}
          rowKey="correctTerm"
          scroll={{ x: '100%' }}
          pagination={false}
        />
      </Content>
      <Modal
        title="Sözlük düzenle"
        visible={editDictionaryModalVisible}
        onCancel={() => setEditDictionaryModalVisible(false)}
        onOk={onModalOk}
      >
        <Form form={form} layout="vertical">
          <Form.Item name="correctTerm" label="Doğru terim">
            <Input />
          </Form.Item>
          <Form.Item name="termsGroup" label="Alternatif terimler">
            <Select mode={'tags'} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
